import React from "react";
import "./View_cart_modal.css";
import { Modal, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBagShopping, faXmark } from "@fortawesome/free-solid-svg-icons";
import Dark_Gray_Btn from "../common_btn/dark_gray_btn/Dark_Gray_Btn";
import { Link, useNavigate } from "react-router-dom";

function View_cart_modal({ show, handleClose, handleViewCart }) {
      const navigate = useNavigate();
  return (
    <>
      <section className="View_cart_modal">
        <Modal
          show={show}
          onHide={handleClose}
          centered
          dialogClassName="View_cart_modal_dialog"
          contentClassName="View_cart_modal_content"
        >
          <Modal.Body className="View_cart_modal_body">
            <button
              type="button"
              className="View_cart_modal_close_btn"
              onClick={handleClose}
            >
             <FontAwesomeIcon icon={faXmark} />
            </button>

            <div className="View_cart_modal_icon_box">
              <FontAwesomeIcon
                icon={faBagShopping}
                className="View_cart_modal_icon"
              />
            </div>

            <p className="View_cart_modal_text">
              THIS ITEM HAS BEEN ADDED TO THE CART
            </p>

           <Dark_Gray_Btn btnText={"View Cart"} onClick={() => navigate("/luxury/cart")} />
          </Modal.Body>
        </Modal>
      </section>
    </>
  );
}

export default View_cart_modal;
